export default 'admin'
